import type { FC } from 'react';
import type { InfluencerSubscriptionCampaignModalContentProps } from '../influencer-subscription-campaign-modal/influencer-subscription-campaign-modal.types';
import { StyledCampaignTitle, StyledModalContainer } from './modal-content.styles';
export const FireshipModalContent: FC<InfluencerSubscriptionCampaignModalContentProps> = ({
  campaign,
  userFriendlyName
}) => {
  return <StyledModalContainer data-sentry-element="StyledModalContainer" data-sentry-component="FireshipModalContent" data-sentry-source-file="fireship.modal.tsx">
      <StyledCampaignTitle data-testid="campaign-title" data-sentry-element="StyledCampaignTitle" data-sentry-source-file="fireship.modal.tsx">{userFriendlyName} Viewers Exclusive</StyledCampaignTitle>
      <h2>Welcome to TryHackMe!</h2>
      <p data-testid="campaign-promotion-text">
        You&apos;ve unlocked a special offer! <br />
        {campaign?.amount === 30 ? <>
            You&apos;ve <span>scored 30%</span> off premium &ndash; 20% for {userFriendlyName} fans, plus a 10% flash
            bonus. Grab it before it&apos;s gone!
          </> : <>
            {userFriendlyName} viewers get <span>20% off</span> our premium subscription!
          </>}
      </p>
    </StyledModalContainer>;
};